import React, { Fragment } from "react";
import { Controller } from "react-hook-form";
import { Input, PasswordInput } from "../../../../components/form/Input/Input";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";

export const UserInfo = ({ register, control, canChange2FA, canChangeUserEmail, logs }) => {
  return (
    <>
      <div className="admin-users__info">
        <div className="admin-users__section">
          <Input label="First Name" htmlFor="first_name" customProps={register("first_name")} />
          <Input label="Last Name" htmlFor="last_name" customProps={register("last_name")} />
          <Input
            label="Email"
            htmlFor="email"
            customProps={register("email", { disabled: !canChangeUserEmail })}
          />
        </div>

        <div className="admin-users__section">
          <PasswordInput label="Password" customProps={register("password")} htmlFor="password" />
          <PasswordInput
            label="Password Confirmation"
            customProps={register("password_confirmation")}
            htmlFor="password_confirmation"
          />
          <Input
            label="Phone number"
            htmlFor="phone_number"
            placeholder="+1 (999) 999 9999"
            customProps={register("phone_number")}
          />
        </div>

        <div className="admin-users__section">
          {canChange2FA && (
            <>
              <div className="switch">
                <p className="switch__title">Enabled 2fa</p>
                <Controller
                  control={control}
                  name="enabled_2fa"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                        <ToggleableButton
                          isRadio
                          title="enabled_2fa"
                          isActive={value}
                          onClick={(isActive) => onChange(isActive)}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div className="switch">
                <p className="switch__title">Hide 2fa by email link</p>
                <Controller
                  control={control}
                  name="disabled_2fa_by_email"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                        <ToggleableButton
                          isRadio
                          title="disabled_2fa_by_email"
                          isActive={value}
                          onClick={(isActive) => onChange(isActive)}
                        />
                      </div>
                    );
                  }}
                />
              </div>

              <div className="admin-users__dropdown">
                <p>Days interval 2fa</p>
                <Controller
                  control={control}
                  name="days_interval_2fa"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Dropdown
                        height={275}
                        haveOnSelectChange
                        options={[1, 7, 14, 21]}
                        selectedFilters={value}
                        onSelectChange={(data) => onChange(data)}
                      />
                    );
                  }}
                />
              </div>
            </>
          )}
        </div>

        <div className="admin-users__section">
          <div className="admin-users__date">
            <p>Expires at</p>

            <Controller
              control={control}
              name="expires_at"
              render={({ field: { onChange, onBlur, value } }) => {
                return (
                  <ReactDatePicker
                    showDefaultInputIcon={false}
                    showClearDate
                    onBlur={onBlur}
                    startDate={value}
                    allowAllDays
                    updateDates={(data) => onChange(data)}
                  />
                );
              }}
            />
          </div>

          <div className="switch">
            <p className="switch__title">Password Changed</p>
            <Controller
              control={control}
              name="password_changed"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="password_changed"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
          <div className="switch">
            <p className="switch__title">TOS Accepted</p>
            <Controller
              control={control}
              name="accepted_tos_at"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="accepted_tos_at"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
        </div>

        <div className="admin-users__section">
          <div className="switch">
            <p className="switch__title">Inactive Client</p>
            <Controller
              control={control}
              name="inactive"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="inactive"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
        </div>
      </div>

      {logs &&
        logs.map(({ event, date, creator }) => {
          return (
            <Fragment key={`${event}-${date}`}>
              <p>
                Date {event}: {date}
              </p>
              <p>
                {event} by {creator}
              </p>
            </Fragment>
          );
        })}
    </>
  );
};
